import { render, staticRenderFns } from "./ShipperFilter.vue?vue&type=template&id=5bf33b3c&"
import script from "./ShipperFilter.vue?vue&type=script&lang=js&"
export * from "./ShipperFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports